<div id="container">
    <canvas #canvas></canvas>
</div>